import { Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import React, { useState, useEffect } from 'react';

// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Box , Stack, TextField, Card, Collapse, Snackbar, Alert } from '@mui/material';

// components
import { useSelector } from 'react-redux';
import active from './active.gif';
import pic from './mail2.png';
import pic2 from './mail.png';

import Page from '../../components/Page';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: '80%',
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
  marginTop:'-5rem',
}));

function CountdownTimer({ minutes, onExpire, sentEmail }) {
  const [secondsLeft, setSecondsLeft] = useState(minutes * 60);
  const [showForm, setShowForm] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');

  useEffect(() => {
    const lastSent = localStorage.getItem("lastActivationEmailSent");
    if (lastSent) {
      const diff = Date.now() - parseInt(lastSent, 10);
      const remaining = minutes * 60 * 1000 - diff;
      if (remaining > 0) {
        setSecondsLeft(Math.floor(remaining / 1000));
      } else {
        setSecondsLeft(0);
      }
    }

    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const minutesLeft = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  if (secondsLeft > 0) {
    return (
      <Button variant="outlined" disabled>
        إعادة الإرسال متاحة بعد {minutesLeft}:{seconds < 10 ? `0${seconds}` : seconds}
      </Button>
    );
  }

  return (
    <Box>
      <Typography sx={{ color: 'error.main', mb: 2, fontSize: '0.9rem' }}>
        ⚠️ من فضلك راجع البريد جيدًا قبل إعادة الإرسال  
        <br /> ⚠️ Please double-check your email before resending
      </Typography>

      <Button
        variant="contained"
        onClick={() => {
          localStorage.setItem("lastActivationEmailSent", Date.now().toString());
          localStorage.setItem("lastActivationEmailAddress", sentEmail);
          onExpire(sentEmail);
        }}
      >
        إعادة إرسال رسالة التفعيل
      </Button>

      <Typography sx={{ mt: 2, color: 'error.main', fontSize: '0.85rem' }}>
        إذا كنت تعتقد أن عنوان بريدك تم كتابته بالخطأ يمكنك 
        <Button variant="text" sx={{ color: 'primary.main', textDecoration: 'underline' }} onClick={() => setShowForm(!showForm)}>
          تعديله من هنا
        </Button>
      </Typography>

      <Collapse in={showForm}>
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            type="email"
            label="New email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            type="email"
            label="Confirm new email"
            value={confirmEmail}
            onChange={(e) => setConfirmEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Typography sx={{ color: 'error.main', mb: 2, fontSize: '0.85rem' }}>
            ⚠️ سيتم تغيير عنوان البريد الإلكتروني وإعادة إرسال رسالة التفعيل على البريد الجديد
          </Typography>
          <Button
            variant="contained"
            onClick={() => {
              if (newEmail && confirmEmail && newEmail === confirmEmail) {
                localStorage.setItem("lastActivationEmailSent", Date.now().toString());
                localStorage.setItem("lastActivationEmailAddress", newEmail);
                onExpire(newEmail);
                setShowForm(false);
              }
            }}
          >
            تأكيد تغيير البريد
          </Button>
        </Box>
      </Collapse>
    </Box>
  );
}

export default function ConfirmMail (){
  const [con , setCon]=useState(false);
  const [sentEmail, setSentEmail] = useState('');
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'info' });
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const confirmHandler = async (overrideEmail = null) => {
    const url =`${process.env.REACT_APP_API_KEY}/api/v1/accounts/update-email-before-activation/`;
    const config  = {
      headers : {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userInfo?.access}`,
      }
    };
    const email = overrideEmail || userInfo?.email;
    console.log("Sending email:", email);
    try {
      await axios.post(url, { email }, config);
      setCon(true);
      setSentEmail(email);
      localStorage.setItem("lastActivationEmailSent", Date.now().toString());
      localStorage.setItem("lastActivationEmailAddress", email);
      setAlert({ open: true, message: "✅ تم إرسال رسالة التفعيل بنجاح", severity: "success" });
    } catch (err) {
      const errorMsg = err.response?.data?.error || "حدث خطأ غير متوقع";
      setAlert({ open: true, message: `❌ ${errorMsg}`, severity: "error" });
      console.error("Error:", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    const lastSent = localStorage.getItem("lastActivationEmailSent");
    const lastEmail = localStorage.getItem("lastActivationEmailAddress");
    if (lastSent && lastEmail) {
      const diff = Date.now() - parseInt(lastSent, 10);
      const remaining = 3 * 60 * 1000 - diff;
      if (remaining > 0) {
        setCon(true);
        setSentEmail(lastEmail);
      }
    }
  }, []);

  return (
    <>
      {userInfo.isVerified === false?(
        <Page title="Confirm Email">
          {con === false?  (
            <ContentStyle>
              <Stack sx={{alignItems: 'center' }}>
                <Box sx={{maxWidth:'350px' }}>
                  <img src={pic2} alt='' />
                </Box>
                <Box  sx={{ textAlign: 'center', alignItems: 'center'}}>
                  <Typography sx={{ color: 'black' , fontSize:'1.2rem' , fontWeight:'600' }}>
                    Please, make sure this is your mail!
                  </Typography>
                  <Typography sx={{ color: 'gray' , fontSize:'1.2rem' , fontWeight:'600'}}>
                    {userInfo?.email} 
                  </Typography>   
                  <Button  
                    onClick={ () =>confirmHandler()} 
                    size="large"  
                    variant="contained"  
                    component={RouterLink} 
                    sx={{ padding:'1rem 2rem' , margin:'1.5rem'}}>
                    Send activation mail now
                  </Button>
                </Box>
              </Stack>
            </ContentStyle>
          ):(
            <ContentStyle sx={{ textAlign: 'center', alignItems: 'center'}}>
              <Card sx={{ p: 4, boxShadow: 3 }}>
                <Box sx={{maxWidth:'250px', mx:'auto', mb:2}}>
                  <img src={pic} alt='' style={{width:'100%'}} />
                </Box>
                <Typography sx={{ color: 'black' , fontSize:'1.2rem' , fontWeight:'600'}}>
                  ✅ لقد أرسلنا رسالة تأكيد إلى البريد الإلكتروني: <strong>{sentEmail}</strong>  
                  <br/> قد تجد الرسالة في مجلد الرسائل غير المرغوب فيها (Spam). من فضلك تحقق من جميع صناديق البريد.
                  <br/><br/>
                  ✅ We have sent a confirmation message to: <strong>{sentEmail}</strong>  
                  <br/> Please check your inbox and also the Spam/Junk folder.
                </Typography>
                <CountdownTimer minutes={3} onExpire={confirmHandler} sentEmail={sentEmail} />
              </Card>
            </ContentStyle>
          )}
        </Page>
      ):(
        <Page title="Already Active">
          <ContentStyle sx={{ textAlign: 'center', alignItems: 'center'}}>
            <Box sx={{maxWidth:'350px'}}>
              <img src={active} alt='' />
            </Box>
            <Typography sx={{ color: 'black' , fontSize:'3rem' , fontWeight:'600'}}>
            Your account is already active <br/> ----------------------
          </Typography>
          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Go to Home
          </Button>
        </ContentStyle>
      </Page>
    )}

    {/* Snackbar لعرض رسائل النجاح أو الخطأ */}
    <Snackbar 
      open={alert.open} 
      autoHideDuration={4000} 
      onClose={() => setAlert({ ...alert, open: false })}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert 
        onClose={() => setAlert({ ...alert, open: false })} 
        severity={alert.severity} 
        sx={{ width: '100%' }}
      >
        {alert.message}
      </Alert>
    </Snackbar>
    </>
  );
};
